// Parses a 'YYYY-MM-DD' release date into a local Date, avoiding the UTC
// shift `new Date(s)` would apply to a bare date string.
export function parseDateStr(s: string | null): Date | undefined {
  if (!s) return undefined;
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
}
